import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const Promesa = () => {
  return (
    <Box py={{ xs: 2, md: 3 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        variant="overline"
        color="primary"
        align="center"
        display="block"
        gutterBottom
      >
        La promesa
      </Typography>
      <Box
        component={Typography}
        fontWeight={800}
        variant="h4"
        gutterBottom
        align="center"
        sx={{ maxWidth: 980, mx: 'auto' }}
      >
        “Deja que el mundo disfrute de lo que tienes que decir, mientras brillas y aprendes a hablar con seguridad.”
      </Box>
      <Typography
        variant="body1"
        align="center"
        color="textSecondary"
        sx={{ maxWidth: 860, mx: 'auto' }}
      >
        En la vida actual, tu voz es tu activo más valioso.{' '}
        Esta mentoría no es solo para aprender a hablar; es para aprender a <strong>influir</strong>. Tienes en tus
        manos un espacio de alto nivel para dominar la escena, ya sea frente a un auditorio o ante la lente de tu
        celular.
      </Typography>
    </Box>
  );
};

export default Promesa;

